// extracted by mini-css-extract-plugin
module.exports = {"body":"ButtonAddShop_body__1yQ8D","button":"ButtonAddShop_button__3ZiGd"};